const n=(...n)=>{if("undefined"==typeof window)return{};const e=new URL(window.location.toString()).searchParams;return n.reduce((n,t)=>{const r=e.get(t);return null===r?n:{...n,[t]:r}},{})};export{n as default};
//# sourceMappingURL=getQueryParams.js.map
